const linksHasLevel3 = document.querySelectorAll(".has-level-3");
linksHasLevel3.forEach((link) => {

	link.addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();
		const uid = link?.parentElement?.getAttribute("data-uid");
		const openLevel3Menu = document.querySelector(".menu-level-3.show") as HTMLElement;
		if (openLevel3Menu) {
			openLevel3Menu.classList.remove("show");
		}
		const level3Menu = document.querySelector(`.menu-level-3[data-sub-menu="${uid}"]`);
		level3Menu?.classList.toggle("show");
	});
});

const dropdowns = document.querySelectorAll('header .dropdown-toggle') as NodeListOf<HTMLElement>;

dropdowns.forEach((dropdown) => {
	const main = document.querySelector('main') as HTMLElement;

	dropdown.addEventListener('show.bs.dropdown', event => {
		dropdown.nextElementSibling?.classList.add('show');

		// Setze die Klasse dropdown-open nur, wenn noch keine Dropdowns offen sind
		if (!main.classList.contains('dropdown-open')) {
			main.classList.add('dropdown-open');
		}
	});

	dropdown.addEventListener('hidden.bs.dropdown', event => {
		dropdown.nextElementSibling?.classList.remove('show');

		// Prüfe, ob nach dem Schließen eines Dropdowns noch andere geöffnet sind
		const anyDropdownOpen = Array.from(dropdowns).some(d => {
			return d.classList.contains('show');
		});

		// Entferne die Klasse dropdown-open nur, wenn keine anderen Dropdowns geöffnet sind
		if (!anyDropdownOpen) {
			main.classList.remove('dropdown-open');
		}

		const openLevel3Menu = document.querySelector('.menu-level-3.show') as HTMLElement;
		if (openLevel3Menu) {
			openLevel3Menu.classList.remove('show');
		}
	});
});


let isAnyOffcanvasShown = false;
const svgStartAni = document.getElementById('startAnimation') as unknown as SVGAnimateElement;
const svgEndAni = document.getElementById('endAnimation') as unknown as SVGAnimateElement;
function checkOffcanvasStatus() {
	const offcanvasElements = document.querySelectorAll('.offcanvas');
	isAnyOffcanvasShown = Array.from(offcanvasElements).some(element => element.classList.contains('show'));
}
const navbarToggler = document.getElementById('navbar-toggler') as HTMLElement;
if (navbarToggler) {
	navbarToggler.addEventListener('click', function () {
		if (!isAnyOffcanvasShown) {
			svgStartAni?.beginElement();
			isAnyOffcanvasShown = true;
		}

	});
}

const offcanvasElements = document.querySelectorAll('.offcanvas')
if (offcanvasElements.length > 0) {
	offcanvasElements.forEach(offcanvas => {
		offcanvas.addEventListener('shown.bs.offcanvas', () => {
			if (!isAnyOffcanvasShown && svgStartAni) {
				svgStartAni.beginElement();
			}
		});

		offcanvas.addEventListener('hidden.bs.offcanvas', () => {
			setTimeout(() => {
				checkOffcanvasStatus();
				if (!isAnyOffcanvasShown && svgEndAni) {
					svgEndAni.beginElement();
				}
			}, 200);
		});
	});
}

function setActiveStatusToParentOffcanvas() {
	const activeElement = document.querySelector('.offcanvas .active') as HTMLElement;
	if (!activeElement) {
		return;
	}
	const closestOffcanvas = activeElement?.closest('.offcanvas') as HTMLElement;
	if (closestOffcanvas.classList.contains('offcanvas-level-3')) {
		const offcanvasId = activeElement?.closest('.offcanvas')?.getAttribute('id');

		const parentOffcanvasBtn = document.querySelector(`.offcanvas [data-bs-target="#${offcanvasId}"]`) as HTMLElement;
		parentOffcanvasBtn?.classList.add('sub-item-active');
		const parentParentId = parentOffcanvasBtn?.closest('.offcanvas')?.getAttribute('id');

		const parentParentOffcanvasBtn = document.querySelector(`.offcanvas [data-bs-target="#${parentParentId}"]`) as HTMLElement;
		parentParentOffcanvasBtn?.classList.add('sub-item-active');
	}
	else if (closestOffcanvas.classList.contains('offcanvas-level-2')) {
		const offcanvasId = activeElement?.closest('.offcanvas')?.getAttribute('id');
		const parentOffcanvasBtn = document.querySelector(`.offcanvas [data-bs-target="#${offcanvasId}"]`) as HTMLElement;
		parentOffcanvasBtn?.classList.add('sub-item-active');
	}
}

if (window.innerWidth < 1400) {
	setActiveStatusToParentOffcanvas();
}

const jumpMarkerMenu = document.querySelector('.jump-marker-menu-js') as HTMLElement;
if (jumpMarkerMenu) {
	const jumpMarkerMenuItems = document.querySelectorAll('.jump-marker-menu-js a') as NodeListOf<HTMLAnchorElement>;
	jumpMarkerMenuItems.forEach((item) => {
		item.addEventListener('click', (e) => {
			e.preventDefault();
			const targetId = item.getAttribute('href')?.replace('#', '') as string;
			scrollToElementInView(targetId);
		});
	});
	// if scrolled window > 100px add class to jumpMarkerMenu
	window.addEventListener('scroll', function () {
		if (window.scrollY > 50 && this.window.innerWidth > 1400) {
			jumpMarkerMenu.classList.add('fixed');
		} else {
			jumpMarkerMenu.classList.remove('fixed');
		}
	});
}

function scrollToElementInView(elementId: string) {
	const element = document.getElementById(elementId);
	if (element) {
		element.scrollIntoView({
			behavior: 'smooth',  // Glattes Scrollen
			block: 'center'      // Element wird in die Mitte des Viewports gebracht
		});
	}
}


// scroll section with ids smooth to the top with fixed header
const links = document.querySelectorAll('a[href^="#"]');
links.forEach(link => {
	link.addEventListener('click', (e) => {
		const href = link.getAttribute('href') as string;
		if (!href || href === '#' || !/^#[\w-]+$/.test(href)) {
			return;
		}

		e.preventDefault();
		const target = document.querySelector(href) as HTMLElement;
		if (target) {
			const top = target.getBoundingClientRect().top + window.scrollY - 300;
			window.scrollTo({
				top,
				behavior: 'smooth'
			});
		}
	});
});


